import { render, staticRenderFns } from "./wallet_out.vue?vue&type=template&id=87cb0fa4&scoped=true&"
import script from "./wallet_out.vue?vue&type=script&lang=js&"
export * from "./wallet_out.vue?vue&type=script&lang=js&"
import style0 from "./wallet_out.vue?vue&type=style&index=0&id=87cb0fa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cb0fa4",
  null
  
)

export default component.exports